import { useSelector } from 'react-redux'
import { selectCurrentToken } from "../auth/authSlice"
import jwtDecode from 'jwt-decode'
import { useMemo } from 'react'

const useAuth = () => {
    const token = useSelector(selectCurrentToken);
    
    return useMemo(() => {
        if (token) {
            const decoded = jwtDecode(token)
            if(decoded.UserInfo.supportuser){
                const { id, email, roles, store, supportuser } = decoded.UserInfo;
                return {id, email, roles, store, supportuser}
            }
            const { id, email, designation, designationSuffix, office, numSuffix, roles } = decoded.UserInfo;
            return { id, email, designation, designationSuffix, office, numSuffix, roles}        
        }
        return { email: '', designation:{}, designationSuffix:{}, office:[], numSuffix:{}, roles: [] }
    }, [token]);
}

export default useAuth